/**
 * @param e
 * @param beforeRef
 * @param afterRef
 */
export function handleScroll(e, beforeRef, afterRef, callback) {
  const afterWidth =
    e.target.scrollWidth - (e.target.offsetWidth + e.target.scrollLeft);
  afterRef.style.opacity = afterWidth > 0 ? afterWidth / 10 : 0;

  const beforeWidth = e.target.scrollLeft;
  beforeRef.style.opacity = beforeWidth ? beforeWidth / 10 : 0;

  if(callback) callback();
}

/**
 * @param ()
 * @param ulRef
 * @param beforeRef
 * @param afterRef
 */
export function handleScrollRepresentation(ulRef, beforeRef, afterRef, callback) {
  if (ulRef.offsetWidth !== ulRef.scrollWidth) {
    afterRef.style.opacity = 1;

    ulRef.addEventListener("scroll", (e) =>
      handleScroll(e, beforeRef, afterRef, callback)
    );
  } else {
    afterRef.style.opacity = 0;
    beforeRef.style.opacity = 0;
    ulRef.removeEventListener("scroll", (e) =>
      handleScroll(e, beforeRef, afterRef, callback)
    );
  }
}



// WEBPACK FOOTER //
// ./src/utils/handleScrollRepresentation.js